// removed by extract-text-webpack-plugin
module.exports = {"item":"styles__item___23IhB","borders":"styles__borders___uPssm","border":"styles__border___2LyAf","catNav":"styles__catNav___1jfrp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Category/styles.scss
// module id = 98
// module chunks = 0